import { getCountries, getCountryCallingCode } from 'libphonenumber-js'

export function countryCodeToFlagEmoji(countryCode: string): string {
  return countryCode
    .toUpperCase()
    .replace(/./g, char =>
      String.fromCodePoint(127397 + char.charCodeAt(0))
    );
}

export function getCountryName(countryCode: string, locale = 'en'): string {
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(countryCode) || countryCode;
  } catch {
    return countryCode;
  }
}

export function getAllCountries(locale = 'en') {
  return getCountries().map(code => ({
    code,
    name: getCountryName(code, locale),
    callingCode: '+' + getCountryCallingCode(code),
    flag: countryCodeToFlagEmoji(code)
  }));
} 